<tabs-inner-wrap>
  <simulation-information></simulation-information>
  <personal-information></personal-information>
  <simulation-details-information></simulation-details-information>
</tabs-inner-wrap>
